import React from 'react';
import { Table } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

export const AccessLogsTableHeader = ({ className }) => (
  <Table.Header className={className}>
    <Table.Row>
      <Table.HeaderCell>
        <FormattedMessage id="category" />
      </Table.HeaderCell>
      <Table.HeaderCell>
        <FormattedMessage id="time" />
      </Table.HeaderCell>
      <Table.HeaderCell>
        <FormattedMessage id="user" />
      </Table.HeaderCell>
      <Table.HeaderCell>
        <FormattedMessage id="company" />
      </Table.HeaderCell>
      <Table.HeaderCell>
        <FormattedMessage id="zone" />
      </Table.HeaderCell>
      <Table.HeaderCell>
        <FormattedMessage id="device" />
      </Table.HeaderCell>
      <Table.HeaderCell>
        <FormattedMessage id="credentials" />
      </Table.HeaderCell>
      <Table.HeaderCell width={3}>
        <FormattedMessage id="detail" />
      </Table.HeaderCell>
    </Table.Row>
  </Table.Header>
);
